import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Box } from '@lightspeed/flame/Core';
import { themeGet } from '@styled-system/theme-get';

interface HeadTrProps {
  lineNumber: number;
  isGroupedItemHead: boolean;
  hasGroupedItems: boolean;
}

interface GroupedItemProps {
  isGroupedItem: boolean;
}

interface IsLastProps {
  isLastGroupedItem: boolean;
}

type ItemTdProps = GroupedItemProps & { as: string; colSpan?: number };

type TrProps = IsLastProps & HeadTrProps;

type GroupedItemBorderBottomProps = Pick<HeadTrProps, 'hasGroupedItems' | 'isGroupedItemHead'>;

const groupedItemHeadBorderBottom = (props: GroupedItemBorderBottomProps) => {
  if (!props.isGroupedItemHead) return;
  if (!props.hasGroupedItems)
    return css`
      &&& td {
        border-bottom: solid 1px ${themeGet('colors.gray-50')(props)};
      }
    `;

  return css`
    &&& td {
      border: none;
    }
  `;
};

export const HeadTr = styled('tr')<TrProps>`
  ${groupedItemHeadBorderBottom}
`;

const groupedItemStyles = (props: ItemTdProps) =>
  props.isGroupedItem &&
  css`
    && {
      border-top: none;
      border-bottom: none !important;
      padding-top: 0;
      padding-bottom: ${themeGet('space.2')(props)};
    }
  `;

export const ItemTd = styled(Box)<ItemTdProps>`
  ${groupedItemStyles}
`;

const groupedItemBorderBottom = (props: TrProps) =>
  props.isLastGroupedItem
    ? css`
        &&& td {
          border-bottom: solid 1px ${themeGet('colors.gray-50')(props)} !important;
          padding-bottom: ${themeGet('space.2')(props)};
        }
      `
    : '';

export const ItemTr = styled('tr')<TrProps>`
  ${groupedItemBorderBottom};
`;
